import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'How many accounting businesses are in New York City?',
  answer: 'There are over 3,450 accounting firms in New York City, including sole proprietors, small practices, and large accounting firms across Manhattan, Brooklyn, Queens, the Bronx, and Staten Island. Our New York City accounting database tracks CPAs, tax preparers, bookkeepers, and audit specialists with verified owner contact information.'
}, {
  question: 'Can I try the New York City accounting database for free?',
  answer: 'Yes! Openmart offers a free trial with 100 credits to explore the verified NYC accounting owner database. You can search, filter, and preview verified accounting firm data before committing. Sign up to test the verified data quality, verify email accuracy, and build sample verified New York City accounting email lists at no cost. <a href="#">Sign up for free →</a>'
}, {
  question: 'How accurate is the NYC accounting owner database?',
  answer: 'Our New York City accounting database maintains a 97% accuracy rate for verified emails and phone numbers. We continuously verify NYC accounting owner contacts in real-time to ensure your accounting email list has high deliverability and low bounce rates.'
}, {
  question: 'What is included in the New York City accounting email list?',
  answer: "When you buy New York City accounting leads from Openmart, you get the owner or managing partner's name, verified email address, direct phone number, firm name, physical address, website, employee count, estimated revenue, and specialization (CPA, tax prep, bookkeeping, audit)."
}, {
  question: 'Can I filter the NYC accounting database by borough?',
  answer: 'Yes! You can easily build a borough-level accounting database using our platform. Filter by location to find Manhattan accounting firms, Brooklyn CPAs, Queens tax preparers, or any specific zip code to target local NYC accounting businesses with precision.'
}, {
  question: 'What neighborhoods are covered in the NYC accounting database?',
  answer: 'Our database covers accounting firms across all major NYC neighborhoods, including Midtown, the Financial District, SoHo, Williamsburg, Park Slope, Astoria, Flushing, Fordham, St. George, and more. You can filter by zip code to target specific local areas.'
}, {
  question: 'How do I buy New York City accounting leads?',
  answer: 'You can access the New York City accounting owner database directly through the Openmart web platform to build and export accounting email lists, or use our API to integrate NYC accounting owner contacts directly into your CRM or internal tools.'
}, {
  question: 'How often is the NYC accounting database updated?',
  answer: 'The New York City accounting business database is updated weekly. We constantly crawl public records, professional directories, and corporate filings to add new NYC accounting firms and update existing owner contact information in our database of accounting businesses.'
}, {
  question: 'What boroughs are covered in the NYC accounting database?',
  answer: 'Our New York City accounting database covers all five boroughs: Manhattan, Brooklyn, Queens, The Bronx, and Staten Island. Filter by any borough or zip code to build targeted accounting email lists for local outreach across the entire NYC metro area.'
}];
export function NYCAccountingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-150">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <div className="text-center mb-16" data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-153">
            Frequently asked <span className="text-blue-600" data-id="element-154">questions</span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-155">
            Common questions about the New York City CPA database, accounting
            email list, and bookkeeper contacts
          </p>
        </div>

        <div className="space-y-0 divide-y divide-slate-200" data-id="element-156">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="py-4" data-id="element-157">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left flex justify-between items-center focus:outline-none group" aria-expanded={isOpen} data-id="element-158">
                  <span className={`text-base font-semibold transition-colors pr-8 ${isOpen ? 'text-blue-600' : 'text-slate-900 group-hover:text-blue-600'}`} data-id="element-159">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-blue-600' : 'text-slate-400 group-hover:text-blue-600'}`} data-id="element-160" />
                </button>
                <AnimatePresence data-id="element-161">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-162">
                      <div className="pt-3 pb-1 text-sm text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{
                  __html: faq.answer
                }} data-id="element-163" />
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}